import { render } from "./index.vue?vue&type=template&id=91bf6d0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=91bf6d0a&lang=less&scoped=true"

import exportComponent from "E:\\project\\hkpay\\shop_html\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91bf6d0a"]])

export default __exports__